import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSnsFacebook(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "21",
    fill: "none",
    viewBox: "0 0 10 21",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D92",
    d: "M6.818 20.498v-8.999h2.731L9.996 7.5H6.818V5.552c0-1.029.027-2.052 1.465-2.052H9.74V.641C9.74.598 8.489.5 7.223.5c-2.645 0-4.3 1.657-4.3 4.699V7.5H0v3.999h2.923v8.999z"
  }));
}
var IcSnsFacebook = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSnsFacebook));

export { IcSnsFacebook as I };
